import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const eventMappings = {};
eventMappings[actions.FIND_POLLING_STATION_COMPLETED] = [trackCompleteAction];
eventMappings[actions.FIND_POLLING_STATION_CANCELED] = [trackCancelAction];

export default function trackFindPolingStation(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: state.findPollingStation.actionCompletionTime
    });
}

function trackCancelAction(state) {
    if (!state.findPollingStation.actionPreviouslyCancelled) {
        sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
            ...state.widget,
            action: state.widget.activeAction,
            actionCancelTime: state.findPollingStation.actionCancelledTime
        });

        apiTracking.trackCancelAction(
            state,
            state.findPollingStation.actionCancelledTime
        );
    }
}
